import $ from 'jquery';
import jQuery from 'jquery';
// import 'bootstrap-multiselect';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('jQuery', $);
});

// import { defineNuxtPlugin } from '#app'
// import jQuery from 'jquery'

// export default defineNuxtPlugin(async (nuxtApp) => {
//   if (process.client) {
//     // Assign jQuery globally so bootstrap-multiselect can find it
//     window.$ = window.jQuery = jQuery

//     // Dynamically import bootstrap-multiselect after jQuery is global
//     await import('bootstrap-multiselect')

//     // Optionally provide jQuery globally in Nuxt app context
//     nuxtApp.provide('jquery', jQuery)
//   }
// })


